import { useContext } from 'react'
import AppSettingsContext from '../contexts/AppSettingsContext'
const useAppSettings = () => useContext(AppSettingsContext)
export default useAppSettings